import React from "react";
import PropTypes from "prop-types";
import QandA from "./QandA";
import { Col, Container, Row } from "react-bootstrap";

export default function QuestionList(props) {
  return (
    <Container fluid>
      {props.questions.map((question, index) => (
        <Row className="justify-content-center" key={"row" + index} style={{ paddingTop: "10px" }}>
          <Col lg="8">
            <QandA
              eventKey={index}
              isAdmin={props.isAdmin}
              key={"question" + index}
              onVoteClick={props.updateUsefulnessScore}
              question={question}
            />
          </Col>
        </Row>
      ))}
    </Container>
  );
}

QuestionList.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  questions: PropTypes.array.isRequired,
  updateUsefulnessScore: PropTypes.func.isRequired
};
